import { lazy } from "react";

export const mainRoute = {
  path: "/",
  exact: true,
  component: lazy(() => import("./index")),
};
